(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["seedshop-custom-filters"] && !Shopify.designMode) return;
  try {
    const seedshopFilterSelector = '[data-seedshop-filter-group]';

  function getSeedshopSelectedFilters() {
    const selectedFilters = {};

    document.querySelectorAll(`${seedshopFilterSelector}:checked`).forEach((input) => {
      const group = input.getAttribute('data-seedshop-filter-group');
      if (!group) return;
      selectedFilters[group] = selectedFilters[group] || new Set();
      selectedFilters[group].add(input.value);
    });

    return selectedFilters;
  }

  function applySeedshopCustomFilters() {
    const selectedFilters = getSeedshopSelectedFilters();
    const activeGroups = Object.keys(selectedFilters);
    const cards = document.querySelectorAll('.collection--seedshop-catalog .product-grid__item');
    let visibleCount = 0;

    cards.forEach((card) => {
      const shouldShow = activeGroups.every((group) => {
        const cardValue = card.getAttribute(`data-seedshop-filter-${group}`) || '';
        return selectedFilters[group].has(cardValue);
      });

      card.classList.toggle('seedshop-filter-hidden', !shouldShow);
      if (shouldShow) visibleCount += 1;
    });

    document.querySelectorAll('[data-testid="products-count"] span[role="status"]').forEach((countNode) => {
      countNode.textContent = `${visibleCount} Produkte`;
    });
  }

  document.addEventListener('change', (event) => {
    if (!(event.target instanceof HTMLInputElement)) return;
    if (!event.target.matches(seedshopFilterSelector)) return;
    applySeedshopCustomFilters();
  });

  document.addEventListener('click', (event) => {
    const clearButton = event.target instanceof Element ? event.target.closest('.facets__clear-all-link') : null;
    if (!clearButton) return;

    document.querySelectorAll(seedshopFilterSelector).forEach((input) => {
      input.checked = false;
    });

    applySeedshopCustomFilters();
  });
  } catch(e) { console.error(e); }
})();

})();
